import { ActionTree } from 'vuex';
import { StreamState, ResolutionType } from './types';
import { RootState } from '@/store/types';
import {
  SET_AUDIO_CURRENT_DEVICE,
  SET_AUDIO_DEVICES_LIST,
  SET_VIDEO_DEVICES_LIST,
  SET_VIDEO_CURRENT_DEVICE,
  SET_TEXTTOSPEECH_VOICES_LIST,
  SET_TEXTTOSPEECH_CURRENT_VOICE,
  SET_RESOLUTION,
  CHANGE_IS_CAMERA_LOADING,
  SET_STREAM_CHANGE_COUNT,
} from './mutationTypes';
import { DeviceType } from '@/types/navigator.type';
import { writeStoredVideoDevice } from '@/utils/deviceStorage';

export const actions: ActionTree<StreamState, RootState> = {
  setAudioDevicesList({ commit }, payload: Array<DeviceType> | null) {
    commit(SET_AUDIO_DEVICES_LIST, payload);
  },

  setAudioCurrentDevice({ commit }, payload: DeviceType | null) {
    commit(SET_AUDIO_CURRENT_DEVICE, payload);
  },

  setVideoDevicesList({ commit }, payload: Array<DeviceType> | null) {
    commit(SET_VIDEO_DEVICES_LIST, payload);
  },

  setVideoCurrentDevice({ commit }, payload: DeviceType | null) {
    commit(SET_VIDEO_CURRENT_DEVICE, payload);
    writeStoredVideoDevice(payload);
  },

  setTextToSpeechVoicesList({ commit }, payload: Array<DeviceType> | null) {
    commit(SET_TEXTTOSPEECH_VOICES_LIST, payload);
  },

  setTextToSpeechCurrentVoice({ commit }, payload: DeviceType | null) {
    commit(SET_TEXTTOSPEECH_CURRENT_VOICE, payload);
  },

  setResolution({ commit }, payload: ResolutionType | null) {
    commit(SET_RESOLUTION, payload);
  },

  changeIsCameraLoading({ commit }, isLoading: boolean) {
    commit(CHANGE_IS_CAMERA_LOADING, isLoading);
  },

  changeStreamCount({ commit }, value: number) {
    commit(SET_STREAM_CHANGE_COUNT, value);
  },

  socket_setEnvResolution({ dispatch }, value: ResolutionType) {
    dispatch('setResolution', value);
  },
};
